@if (badge$ | async; as badge) {
    <ul class="sh-tag-list digihaven-format-badge">
        <li class="sh-tag--readonly -sh-small sh-tag-list__item">
            @if (badge.previewRecordId) {
                <digihaven-format-preview-link [label]="badge.label" [recordId]="badge.previewRecordId" [roles]="badge.roles" />
            } @else {
                <span class="sh-tag__label">{{ badge.label }}</span>
            }
        </li>
    </ul>
} @else {
    {{ defaultValue$ | async }}
}
